import CONFIGS from 'build/Config'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import { Link } from 'react-router-dom'

const BackIcon = () => {
  return (
    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.96094 0.0859375L8.03906 1.16406L2.95312 6.25H18V7.75H2.95312L8.03906 12.8359L6.96094 13.9141L0.585938 7.53906L0.0703125 7L0.585938 6.46094L6.96094 0.0859375Z" fill="currentColor" />
    </svg>
  )
}

const DynamicIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 2V10M10 6H2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

const goHome = () => {
  dlTrackEvent('user_interaction', {
    action: 'click',
    element: 'home :: ranking',
    section: 'ranking'
  })
}

const goDynamic = () => {
  dlTrackEvent('user_interaction', {
    action: 'click',
    element: 'dynamic :: ranking',
    section: 'ranking'
  })
}

const Header = () => {
  return (
    <nav className='ranking__header'>
      <Link to="/" onClick={goHome} className='ranking__header__back'>
        <BackIcon />
        <h2>
          RANKING
        </h2>
      </Link>

      {!CONFIGS?.rankingDisabled &&
        <Link to="/album/start" onClick={goDynamic}>
          <div className='ranking__header__dynamic'>
            <DynamicIcon />
            <h2>
              Ver retos
            </h2>
          </div>
        </Link>
      }
    </nav>
  )
}

export default Header